module.exports = __webpack_public_path__ + "static/covidSocial-143342605df311ecf1496319756d4347.jpg";